enum EHeyLibbyAdminNavItemNames {
  home = 'Home',
  orgsAndUsers = 'Orgs & Users',
  agents = 'Agents',
  phoneNumbers = 'Phone Numbers',
  usageReports = 'Usage Reports',
  serviceTemplates = 'Service Templates',
  partnerManagement = 'Partner Management',
  promptMetadata = 'Prompt Metadata',
  siteMetadata = 'Site Metadata',
  campaignTemplates = 'Campaign Templates',
  planMetadata = 'Plan & Add-On Metadata',
  voiceTemplates = 'Voice Templates',
  adminPortalConfig = 'Portal Config',
  adminPortalGeneralSettings = 'General Settings',
  adminPortalBranding = 'Branding',
  manageAdminUsers = 'Manage Admin Users',
}

export default EHeyLibbyAdminNavItemNames
